import React, { useState } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import SayfaEkle from './new/SayfaEkle'
import SayfaGuncelle from './update/SayfaGuncelle'
import { useSelector } from 'react-redux'

const Container = styled.div`
    width: 45%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    .title{
        font-size: var(--font-size-lg);
        font-weight: var(--font-weight-lg);
        text-align: center;
    }
`


const AdminSayfaEkleInputContainer = () => {
    const dispatch = useDispatch()
    const { selectedPage } = useSelector((state) => state.admin5)
    
  return (
    <Container>

       <p className='title'>{selectedPage ? "Sayfa Bilgileri" : "Sayfa Ekle"}</p>
        {
        !selectedPage ?
            <SayfaEkle /> 
        :
        selectedPage.permissions.$values.map((item) => (
            <SayfaGuncelle item={item} /> 
        ))
        }
        
    </Container>
  )
}

export default AdminSayfaEkleInputContainer